import { ValidateIf } from '@pristine-ts/class-validator';
import { translationBaseKey } from '../../../../../decorators/translation-base-key.decorator';
import { clonePropertyMetadata } from '@pristine-ts/metadata';
import {
  IncomeTaxPersonalSpouseFederalInIncomeTaxPersonalOptions,
} from '../../../income-tax/personal/personal/income-tax-personal-spouse-federal-in-income-tax-personal.options';

@translationBaseKey('income-tax-personal-spouse-federal-in-salary-dividend-options')
export class IncomeTaxPersonalSpouseFederalInSalaryDividendOptions implements IncomeTaxPersonalSpouseFederalInIncomeTaxPersonalOptions {

  @clonePropertyMetadata<IncomeTaxPersonalSpouseFederalInIncomeTaxPersonalOptions>(IncomeTaxPersonalSpouseFederalInIncomeTaxPersonalOptions, 'maximumAllowedDeductibleContributionsRRSP')
  @ValidateIf(o => o.paidContributionRRSP > 0)
    // todo set a warning if paid contribution > maximum allowed.
  maximumAllowedDeductibleContributionsRRSP: number = 0;

  @clonePropertyMetadata<IncomeTaxPersonalSpouseFederalInIncomeTaxPersonalOptions>(IncomeTaxPersonalSpouseFederalInIncomeTaxPersonalOptions, 'paidContributionRRSP')
  paidContributionRRSP: number;
}
